export default __webpack_public_path__ + "static/media/2.ac5c8858.png";